/* LW B2B Firmenpflicht - separat vom Produkt-/Upload-/Rechnungsprozess. */
(() => {
  'use strict';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let busy = false;
  const error = (block, message) => { const el = block && block.querySelector('[data-lw-b2b-error]'); if (el) { el.textContent = message; el.hidden = !message; } };
  document.addEventListener('input', event => {
    if (event.target.matches('[data-lw-b2b-company]')) {
      event.target.setCustomValidity('');
      error(event.target.closest('[data-lw-b2b-form]'), '');
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-lw-b2b-confirm]')) {
      error(event.target.closest('[data-lw-b2b-form]'), '');
    }
  });
  document.addEventListener('click', async event => {
    const checkout = event.target.closest('[data-lw-b2b-checkout]');
    if (!checkout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    const container = checkout.closest('.cart__ctas');
    const block = container && container.querySelector('[data-lw-b2b-form]');
    const company = block && block.querySelector('[data-lw-b2b-company]');
    const agreed = block && block.querySelector('[data-lw-b2b-confirm]');
    if (!company || !agreed) {
      window.alert('Die verpflichtenden Firmenangaben konnten nicht geladen werden. Bitte öffnen Sie den Warenkorb erneut.');
      return;
    }
    company.value = company.value.trim();
    company.setCustomValidity(company.value ? '' : 'Bitte geben Sie Ihren Firmennamen oder Ihre Geschäftsbezeichnung ein.');
    if (!company.reportValidity()) { company.focus(); return; }
    if (!agreed.checked) { error(block, 'Bitte bestätigen Sie Ihre Unternehmereigenschaft gemäß § 14 BGB.'); agreed.focus(); agreed.reportValidity(); return; }
    busy = true;
    checkout.disabled = true;
    error(block, '');
    try {
      const response = await fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({attributes: {'Firmenname': company.value, 'B2B-Unternehmerbestaetigung': 'Ja'}})
      });
      if (!response.ok) throw new Error('Die Firmenangaben konnten nicht gespeichert werden.');
      const updated = await response.json();
      if (!updated.attributes || updated.attributes.Firmenname !== company.value || updated.attributes['B2B-Unternehmerbestaetigung'] !== 'Ja') throw new Error('Shopify hat die Firmenangaben nicht bestätigt.');
      window.location.assign(ROOT + 'checkout');
    } catch (e) {
      console.error('LW B2B checkout:', e);
      error(block, 'Firmenangaben konnten nicht gespeichert werden. Bitte erneut versuchen.');
      checkout.disabled = false;
      busy = false;
    }
  }, true);
})();
